import * as React from "react";
import {Fixture} from "../records/Fixture";
import * as moment from 'moment';

export interface IFixtureListElementViewProps {
    fixture: Fixture
}

export interface IFixtureListElementViewState {
}

export class FixtureListElementView extends React.Component<IFixtureListElementViewProps, IFixtureListElementViewState> {

    constructor(props: any)
    {
        super(props);
        this.state = this.getInitialState();
    }

    private getInitialState()
    {
        return {
        }
    }

    public render()
    {
        let fixture = this.props.fixture;
        let team1 = fixture.participants[0];
        let team2 = fixture.participants[1];
        let team1Name = team1.name ? team1.name : "TBD";
        let team2Name = team2.name ? team2.name : "TBD";
        let startTime = fixture.scheduledStartTime;
        let bo = fixture.format.value;
        let status = fixture.status;

        let score = "VS";

        let vsStyle = "";
        let liveColor;
        let liveDot;
        let startHour;
        const endHour: string | undefined = fixture.endTime ? moment(fixture.endTime).format("HH:mm") : undefined;
        if (status == "Ended")
        {
            score = team1.score + " - " + team2.score;
            startHour = endHour ? `Finished at ${moment(fixture.endTime).format("HH:mm")}` : "Finished";
            vsStyle = "bold";
        }
        else if (status.toLocaleLowerCase() === "forfeited")
        {
            score = team1.score + " - " + team2.score;
            startHour = status;
            vsStyle = "bold";
        }
        else if (status.toLocaleLowerCase() === "cancelled")
        {
            startHour = status;
            vsStyle = "bold";
        }
        else if (status == "Started")
        {
            score = team1.score + " - " + team2.score;
            liveColor = "live";
            startHour = "Live";
            vsStyle = "bold";
            liveDot = (
                <div className="ring-container" style={{display: "inline-block"}}>
                    <div className="ringring"/>
                    <div className="circle"/>
                </div>
            );
        }
        else
        {
            startHour = moment(startTime).format("HH:mm");
        }

        return (
            <div className={"fixtureListElement"}>
                <div className={"fixtureListElement-startTime " + liveColor}>{liveDot} {startHour}</div>
                <div className={"fixtureListElement-team1"}>{team1Name}</div>
                <div className={"fixtureListElement-vs " + liveColor + " " + vsStyle}>{score}</div>
                <div className={"fixtureListElement-team2"}>{team2Name}</div>
                <div className={"fixtureListElement-bo"}>Best of {bo}</div>
            </div>
        );
    }
}